import { compose } from 'ramda';

import { redirectTo, saveReturnPath } from '../../../../store/location/actions';
import { selectQuery } from '../../../../store/location/selectors';
import { isAuthenticatedOrProspect } from '../../../../store/session/selectors';

export const path = '/signup';
export const component = 'Signup';
export const thunk = () => (dispatch, getState) => {
  const state = getState();
  const { returnPath } = selectQuery(state);

  if (isAuthenticatedOrProspect(state)) {
    compose(dispatch, redirectTo)(returnPath);
    return;
  }

  compose(dispatch, saveReturnPath)(returnPath);
};
